import type { FuncaoMembro, UserRole } from '../types'

export const USER_ROLES: UserRole[] = [
  'admin',
  'responsavel_tecnico',
  'caar',
  'piloto',
  'aplicador',
  'auxiliar_campo',
  'observador',
  'motorista',
  'tecnico_agricola',
  'consultor',
  'membro',
]

export const FIELD_USER_ROLES: UserRole[] = [
  'caar',
  'piloto',
  'aplicador',
  'auxiliar_campo',
  'observador',
  'motorista',
  'tecnico_agricola',
]

export const TECHNICAL_USER_ROLES: UserRole[] = [
  'responsavel_tecnico',
  'consultor',
]

export function isUserRole(value: unknown): value is UserRole {
  return typeof value === 'string' && USER_ROLES.includes(value as UserRole)
}

export function isFieldUserRole(role: UserRole | string | null | undefined) {
  return !!role && FIELD_USER_ROLES.includes(role as UserRole)
}

export function isTechnicalUserRole(role: UserRole | string | null | undefined) {
  return !!role && TECHNICAL_USER_ROLES.includes(role as UserRole)
}

export function getRoleLabel(role: UserRole | string | null | undefined) {
  switch (role) {
    case 'admin': return 'Administrador'
    case 'responsavel_tecnico': return 'Responsável técnico'
    case 'caar': return 'CAAR'
    case 'piloto': return 'Piloto remoto'
    case 'aplicador': return 'Aplicador'
    case 'auxiliar_campo': return 'Auxiliar de campo'
    case 'observador': return 'Observador'
    case 'motorista': return 'Motorista'
    case 'tecnico_agricola': return 'Técnico agrícola'
    case 'consultor': return 'Consultor técnico'
    case 'membro': return 'Membro'
    default: return 'Sem papel definido'
  }
}

export function getRoleFromMemberFunction(funcao?: FuncaoMembro | string | null): UserRole {
  switch (funcao) {
    case 'Responsável Técnico':
    case 'Engenheiro Agrônomo':
    case 'Engenheiro Florestal':
      return 'responsavel_tecnico'
    case 'CAAR / Aplicador Aeroagrícola Remoto':
      return 'caar'
    case 'Piloto Remoto':
    case 'Aplicador + Piloto':
      return 'piloto'
    case 'Aplicador Aeroagrícola':
      return 'aplicador'
    case 'Auxiliar de Campo':
      return 'auxiliar_campo'
    case 'Observador':
      return 'observador'
    case 'Motorista':
      return 'motorista'
    case 'Técnico Agrícola':
      return 'tecnico_agricola'
    case 'Consultor Técnico':
      return 'consultor'
    default:
      return 'membro'
  }
}
